module.exports = __webpack_public_path__ + "img/IconAlert.240ed834.svg";